module.exports = __webpack_public_path__ + "img/iconPF.f1dfc3b0.svg";